/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageFragment} from '@amblique/contentful/app/contentful/fragments/page/base-page.fragment';
import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';
import {BaseBlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid/base-blog-grid.fragment';
import {BaseBlogListingFragment} from '@amblique/contentful/app/contentful/fragments/blog-listing/base-blog-listing.fragment';
import {BaseBlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles/base-blog-related-articles.fragment';
import {BaseBreadcrumbFragment} from '@amblique/contentful/app/contentful/fragments/breadcrumb/base-breadcrumb.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';
import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseCategoryCardGridFragment} from '@amblique/contentful/app/contentful/fragments/category-card-grid/base-category-card-grid.fragment';
import {BaseContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/base-container.fragment';
import {BaseDescriptionBlockFragment} from '@amblique/contentful/app/contentful/fragments/description-block/base-description-block.fragment';
import {BaseEditorialWrapperFragment} from '@amblique/contentful/app/contentful/fragments/editorial-wrapper/base-editorial-wrapper.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseFeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/base-feature-list.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseIconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set/base-icon-set.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseKingDifferenceMediaCf013Fragment} from '@amblique/contentful/app/contentful/fragments/king-difference-media-cf013/base-king-difference-media-cf013.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseLoopingTickerFragment} from '@amblique/contentful/app/contentful/fragments/looping-ticker/base-looping-ticker.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseMediaContentSectionFragment} from '@amblique/contentful/app/contentful/fragments/media-content-section/base-media-content-section.fragment';
import {BaseMediaWithScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/media-with-scrollable-text/base-media-with-scrollable-text.fragment';
import {BaseProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles/base-product-tiles.fragment';
import {BaseReviewsFragment} from '@amblique/contentful/app/contentful/fragments/reviews/base-reviews.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseSeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/base-seo.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {BaseShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details/base-showroom-details.fragment';
import {BaseSplitHeadingFragment} from '@amblique/contentful/app/contentful/fragments/split-heading/base-split-heading.fragment';
import {BaseSplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block/base-split-panel-double-image-block.fragment';
import {BaseSplitTextFragment} from '@amblique/contentful/app/contentful/fragments/split-text/base-split-text.fragment';
import {BaseTeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/base-teaser-tile-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const PageFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseBlogFragment}
  ${BaseBlogGridFragment}
  ${BaseBlogListingFragment}
  ${BaseBlogRelatedArticlesFragment}
  ${BaseBreadcrumbFragment}
  ${BaseCardFragment}
  ${BaseCarouselFragment}
  ${BaseCategoryCardGridFragment}
  ${BaseContainerFragment}
  ${BaseDescriptionBlockFragment}
  ${BaseEditorialWrapperFragment}
  ${BaseEmbedPanelFragment}
  ${BaseFeatureListFragment}
  ${BaseHeroBannerFragment}
  ${BaseIconSetFragment}
  ${BaseImageFragment}
  ${BaseKingDifferenceMediaCf013Fragment}
  ${BaseLinkFragment}
  ${BaseLoopingTickerFragment}
  ${BaseMediaCarouselFragment}
  ${BaseMediaContentSectionFragment}
  ${BaseMediaWithScrollableTextFragment}
  ${BasePageFragment}
  ${BaseProductTilesFragment}
  ${BaseReviewsFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseSeoFragment}
  ${BaseShopTheLookFragment}
  ${BaseShowroomDetailsFragment}
  ${BaseSplitHeadingFragment}
  ${BaseSplitPanelDoubleImageBlockFragment}
  ${BaseSplitTextFragment}
  ${BaseTeaserTileBlockFragment}
  ${BaseVideoFragment}

  fragment PageFragment on Page {
    ...BasePageFragment

    mainRegionCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on Blog {
          ...BaseBlogFragment
        }
        ... on BlogGrid {
          ...BaseBlogGridFragment
        }
        ... on BlogListing {
          ...BaseBlogListingFragment
        }
        ... on BlogRelatedArticles {
          ...BaseBlogRelatedArticlesFragment
        }
        ... on Breadcrumb {
          ...BaseBreadcrumbFragment
        }
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on CategoryCardGrid {
          ...BaseCategoryCardGridFragment
        }
        ... on Container {
          ...BaseContainerFragment
        }
        ... on DescriptionBlock {
          ...BaseDescriptionBlockFragment
        }
        ... on EditorialWrapper {
          ...BaseEditorialWrapperFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on IconSet {
          ...BaseIconSetFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on KingDifferenceMediaCf013 {
          ...BaseKingDifferenceMediaCf013Fragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on LoopingTicker {
          ...BaseLoopingTickerFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on MediaContentSection {
          ...BaseMediaContentSectionFragment
        }
        ... on MediaWithScrollableText {
          ...BaseMediaWithScrollableTextFragment
        }
        ... on ProductTiles {
          ...BaseProductTilesFragment
        }
        ... on Reviews {
          ...BaseReviewsFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
        ... on ShowroomDetails {
          ...BaseShowroomDetailsFragment
        }
        ... on SplitHeading {
          ...BaseSplitHeadingFragment
        }
        ... on SplitPanelDoubleImageBlock {
          ...BaseSplitPanelDoubleImageBlockFragment
        }
        ... on SplitText {
          ...BaseSplitTextFragment
        }
        ... on TeaserTileBlock {
          ...BaseTeaserTileBlockFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
    mainRegionCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on Blog {
          ...BaseBlogFragment
        }
        ... on BlogGrid {
          ...BaseBlogGridFragment
        }
        ... on BlogListing {
          ...BaseBlogListingFragment
        }
        ... on BlogRelatedArticles {
          ...BaseBlogRelatedArticlesFragment
        }
        ... on Breadcrumb {
          ...BaseBreadcrumbFragment
        }
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on CategoryCardGrid {
          ...BaseCategoryCardGridFragment
        }
        ... on Container {
          ...BaseContainerFragment
        }
        ... on DescriptionBlock {
          ...BaseDescriptionBlockFragment
        }
        ... on EditorialWrapper {
          ...BaseEditorialWrapperFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on IconSet {
          ...BaseIconSetFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on KingDifferenceMediaCf013 {
          ...BaseKingDifferenceMediaCf013Fragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on LoopingTicker {
          ...BaseLoopingTickerFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on MediaContentSection {
          ...BaseMediaContentSectionFragment
        }
        ... on MediaWithScrollableText {
          ...BaseMediaWithScrollableTextFragment
        }
        ... on ProductTiles {
          ...BaseProductTilesFragment
        }
        ... on Reviews {
          ...BaseReviewsFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
        ... on ShowroomDetails {
          ...BaseShowroomDetailsFragment
        }
        ... on SplitHeading {
          ...BaseSplitHeadingFragment
        }
        ... on SplitPanelDoubleImageBlock {
          ...BaseSplitPanelDoubleImageBlockFragment
        }
        ... on SplitText {
          ...BaseSplitTextFragment
        }
        ... on TeaserTileBlock {
          ...BaseTeaserTileBlockFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
    seo {
      ...BaseSeoFragment
    }
  }
`;
